import styled from 'styled-components';
import { Div, H5, Icon, lightTheme, P, PhoneIcon } from '@vgrubs/components';

/** Global `a:link` / `a:visited` use `text-decoration: none`; underline on hover is applied from the link. */
const TelLink = styled.a`
  text-decoration: none;

  &:hover h5,
  &:hover p {
    text-decoration: underline !important;
  }
`;

export const PhoneNumberText = ({
  phone,
  color,
  title,
}: {
  phone: string;
  color?: string;
  title?: boolean;
}) => {
  const formattedPhone = phone.startsWith('+') ? phone : '+' + phone;
  return (
    <div>
      <TelLink href={`tel:${phone}`} style={{ display: 'inline-block' }}>
        <Div $flex $alignCenter $gap="4px">
          {title ? (
            <H5 $m="0">{formattedPhone}</H5>
          ) : (
            <P $m="0">{formattedPhone}</P>
          )}
          <Div $height="16px">
            <Icon
              $size="16"
              display="inline-block"
              color={color || lightTheme.lightGray}
            >
              <PhoneIcon />
            </Icon>
          </Div>
        </Div>
      </TelLink>
    </div>
  );
};
